/**
 * Banner Notification Models
 * Domain models for banner notifications and maintenance mode
 */

/**
 * Banner notification data structure
 */
export interface BannerNotification {
  id?: number;
  bannerType: string;
  message: string;
  severity?: 'info' | 'warning' | 'error' | 'success';
  dismissible?: boolean;
  startDate?: Date;
  endDate?: Date;
  active?: boolean;
}

/**
 * Maintenance mode data structure
 */
export interface MaintenanceMode {
  enabled: boolean;
  message?: string;
  startTime?: Date;
  endTime?: Date;
  affectedServices?: string[];
}

/**
 * Dismiss banner request
 */
export interface DismissBannerRequest {
  BannerType: string;
}

/**
 * Dismiss banner response
 */
export interface DismissBannerResponse {
  success: boolean;
  message?: string;
}
